
import { defineComponent, ref, computed } from 'vue'
import AdminOverview from './AdminOverview.vue'
import UserManagement from './UserManagement.vue'
import TaskManagement from './TaskManagement.vue'
import PointsLog from './PointsLog.vue'
import FeedbackManagement from './FeedbackManagement.vue'
import WorkerManagement from './WorkerManagement.vue'
import QualitySettings from './QualitySettings.vue'
import CouponManagement from './CouponManagement.vue'

type MenuKey = 'overview' | 'users' | 'tasks' | 'points' | 'feedbacks' | 'workers' | 'quality' | 'coupons'

export default defineComponent({
  name: 'AdminLayout',
  components: { AdminOverview, UserManagement, TaskManagement, PointsLog, FeedbackManagement, WorkerManagement, QualitySettings, CouponManagement },
  emits: [],
  setup() {
    const activeMenu = ref<MenuKey>('overview')

    const menuItems: { key: MenuKey; label: string }[] = [
      { key: 'overview', label: '概览' },
      { key: 'users', label: '用户管理' },
      { key: 'tasks', label: '任务管理' },
      { key: 'points', label: '积分流水' },
      { key: 'feedbacks', label: '反馈管理' },
      { key: 'workers', label: 'Worker 状态' },
      { key: 'quality', label: '质量阈值' },
      { key: 'coupons', label: '兑换码管理' },
    ]

    const pageTitle = computed(() => {
      return menuItems.find((item) => item.key === activeMenu.value)?.label ?? '运营后台'
    })

    const navigateTo = (menu: MenuKey) => {
      activeMenu.value = menu
    }

    return {
      activeMenu,
      menuItems,
      pageTitle,
      navigateTo,
    }
  },
})
